/**
 * in this module there are all the related functions for:
 *  - find fault search events and behaviour
 *  - report handler
 */

import functions from '../common/functions'

/**
 * initialize the fault search
 */

const initFaultSearch = (view, overlay) => {
  /**
   * set the find fault datepicker to today date
   */

  let today = new Date()

  $('#frafindstamp').val(`${functions.leadZero(today.getDate())}/${functions.leadZero(today.getMonth() + 1)}/${today.getFullYear()}`)

  /**
   * set the datepicker options
   */

  $('#frafindstamp').datepicker({
    format: 'dd/mm/yyyy',
    autoclose: true,
    startDate: '01/01/1950',
    endDate: '+20y',
    orientation: 'bottom auto'
  }).on('show', function (e) {
    e.stopPropagation()
  })

  /**
   * hide the search list div
   */

  $('#frasearchcont').hide()

  /**
   * frafindbutton click handler
   */

  $('#frafindbutton').on('click', function () {
    /**
     * hide the popup
     */

    overlay.setPosition(undefined)

    /**
     * get the fault ID from the input element
     * remove any commas
     */

    let getfault = $('#frafindfault').val()
    getfault = getfault.replace(/,/g, ' ')

    /**
     * get the hours selected element
     * get the selected hour
     */

    const sel = document.getElementById('frafindstamph')
    let hour = sel[sel.selectedIndex].value

    /**
     * get the date from the datepicker
     * create the final timestamp
     */

    let getstamp = $('#frafindstamp').val()

    if (getstamp !== '') {
      getstamp = getstamp.split('/').reverse().join('-')
      getstamp = `${getstamp} ${hour}`
    }
    else {
      getstamp = ''
    }

    /**
     * get the selected status
     * save it in an array
     */

    const getstat = []

    $('#statuses :input[type=checkbox]').each(function () {
      if ($(this).is(':checked')) {
        getstat.push($(this).val())
      }
    })

    /**
     * check the criteria and display the correct error
     */

    if (($('#frafindfault').val() === '' && $('#frafindstamp').val() === '' && $('input[type="checkbox"]:checked').length === 0) || ($('input[type="checkbox"]:checked').length === 0)) {
      $('#frasearch_results').empty()
      $('#frasearchcont').show()
      $('#frasearch_results').append($('<h5 />', {
        text: 'Change the criteria.'
      }))
      return
    }

    /**
     * empty the search list div
     */

    $('#frasearch_results').empty()

    /**
     * create the json data
     */

    let theData = '{"findfault": "' + getfault + '", "findstamp": "' + getstamp + '", "findstat": "' + getstat + '"}'

    /**
     * send an ajax reuqest
     */
    $('.loading').show()
    $.ajax({
     url: '/traffweb/fra-find',
     type:"POST",
     data: {
       jdata: theData
     },
     beforeSend: function beforeSend(xhr) {
       xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
     }
    })
      .done((data) => {
        /**
         * parse the result
         */

        data = JSON.parse(data)

        /**
         * check if the response is empty
         * display an error
         */

        if (data.length === 0 || data.length === undefined) {
          $('#frasearch_results').empty()
          $('#frasearch_results').append($('<h5 />', {
            text: 'Fault not found.'
          }))
          $('#frasearchcont').show()
        }

        /**
         * check if the response is just 1 result
         * move the map to the fault
         */

        else if (data.length === 1) {
          let zoom = view.getView().getResolutions()
          view.getView().setResolution(zoom[zoom.length - 1])
          view.getView().centerOn([parseFloat(data[0].easting), parseFloat(data[0].northing)], view.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])

          /**
           * check if it's a mobile device
           * hide the tools menu
           */

          if (functions.mobileTabletView()) {
            $('#dropdownToolsMobile').trigger('click')
          }
        }

        /**
         * else just show the result list
         */

        else {
          $('#frasearchcont').show()
        }

        /**
         * create the li item for each result
         */

        $.each(data, function () {
          /**
           * assign this to place
           */

          let place = this

          /**
           * create a li element
           * append the correct text
           * append to frasearch_results
           * add the click event
           *  - hide the popup
           *  - move the map
           * show frasearch_results
           */

          $('<li>')
            .append($('<a />', {
              text: `Ref: ${place.fref}, Log Time: ${place.stamp}`
            }))
            .appendTo('#frasearch_results').click(function () {
              overlay.setPosition(undefined)
              let zoom = view.getView().getResolutions()
              view.getView().setResolution(zoom[zoom.length - 1])
              view.getView().centerOn([parseFloat(place.easting), parseFloat(place.northing)], view.getSize(), [($(window).innerWidth() / 2), ($(window).innerHeight() / 2)])
            })
            .show()
        })
      }) // end done
      .fail(function (jqxhr, textStatus, error) {
        const err = `${textStatus}, ${error}`
        alert(`THEURLS Request Failed: ${err}`)
      })
      .always(() => {
        /**
         * hide the loading bar
         */

        $('.loading').hide()
      })
  /**
   * end $('#frafindbutton').on('click', function () {
   */
  })

  /**
   * when you press the ENTER key in the search input:
   *  - execute the find function emulating a click on the search button
   */

  $('#frafindfault').keypress(function (e) {
    if (e.which === 13) {
      $('#frafindbutton').click()
    }
  })

/**
 * end const initFaultSearch = (view, overlay) => {
 */
}

/**
 * initialize the report handler
 */

const initReport = () => {

  /**
   * open a new window with the report on change
   */

  $('.reportopt').click(function () {
    /**
     * get the value of the selected option
     */

    let reportType = this.value

    let url = '/genrep'

    /**
     * open a new window with the correct parameters
     */

    if (reportType === '1,2,3') {
      window.open(`${url}?repType=fra&fstatus=1,2,3&criteria=${encodeURIComponent('All faults listed')}`)
    }
    else if (reportType === '1') {
      window.open(`${url}?repType=fra&fstatus=1&criteria=${encodeURIComponent('Pending faults listed')}`)
    }
    else if (reportType === '2') {
      window.open(`${url}?repType=fra&fstatus=2&criteria=${encodeURIComponent('Completed faults listed')}`)
    }
    else if (reportType === '3') {
      window.open(`${url}?repType=fra&fstatus=3&criteria=${encodeURIComponent('Expired faults listed')}`)
    }

  })
}

/**
 * EXPORT
 */

export default {
  initFaultSearch,
  initReport
}
